// frontend/src/data/updates.js
export const updates = [
  {
    version: "Alpha 0.6.8",
    date: "4.5.2026",
    changes: [
      "Balanced mining damage.",
      "Balanced hostile creature spawn rate.",
      "Improved sea ambience audio.",
      "Improved hydration balancing.",
      "Fixed grill meat task progression.",
      "Improved handcrafting system.",
      "Added new eye customization options.",
      "Improved hair customization.",
      "Improved background music and ambience.",
      "Fixed bed CharSM material.",
      "Improved game logo.",
      "Improved respawn behavior.",
    ],
  },
  {
    version: "Alpha 0.6.7",
    date: "27.4.2026",
    changes: [
      "Fixed rain visual issues.",
      "Fixed scooping.",
      "Improved spawn positioning.",
      "Added new door texture.",
      "Improved dialogue system.",
      "Expanded story content.",
      "Added rabbit hunting quest.",
      "Improved quest system.",
      "Improved quest and dialogue editor.",
    ],
  },
  {
    version: "Alpha 0.6.6",
    date: "9.4.2026",
    changes: [
      "Improved quest system.",
      "Improved dialogue system.",
      "Improved node connector visuals.",
      "Fixed overlay align.",
      "Improved quest and dialogue editor.",
    ],
  },
  {
    version: "Alpha 0.6.5",
    date: "7.4.2026",
    changes: [
      "Improved quest and dialogue editor.",
      "Improved dialogue system.",
      "Improved quest system.",
      "Fixed bug chunk actor reprocess cooking pot.",
    ],
  },
  {
    version: "Alpha 0.6.4",
    date: "4.4.2026",
    changes: [
      "Improved campfire system.",
      "Improved NPC behavior and interactions.",
      "Disabled motion blur for cleaner visuals.",
      "Fixed packaged build issues.",
      "Added more animal drops including rawhide.",
    ],
  },
  {
    version: "Alpha 0.6.3",
    date: "1.4.2026",
    changes: [
      "Improved background music and ambience.",
      "Reduced cursor input delay.",
      "Fixed missing sparkling effects.",
      "Fixed packaged build issues.",
      "Improved trading system.",
      "Updated item descriptions.",
      "Added plant fiber clothing.",
      "Fixed handheld.",
    ],
  },
  {
    version: "Alpha 0.6.2",
    date: "28.3.2026",
    changes: [
      "Balanced mining damage.",
      "Fixed bug consume material for craft item stack.",
      "Added vegetation drops.",
      "Improved campfire system.",
      "Fixed texture icon.",
      "Fixed transwater dry.",
      "Balanced hostile creature spawn rate.",
      "Improved roof visuals.",
      "Fixed packaged build issues.",
      "Fixed food cook time.",
      "Added clay crafting items.",
      "Updated item descriptions.",
      "Added collect salt quest.",
    ],
  },
  {
    version: "Alpha 0.6.1",
    date: "25.3.2026",
    changes: [
      "Improved campfire system.",
      "Expanded skill tree system.",
      "Improved NPC behavior and interactions.",
      "Improved sleeping mechanics.",
      "Improved hydration balancing.",
      "Improved trading system.",
      "Improved NPC relationship system.",
      "Added NPC desired items.",
    ],
  },
  {
    version: "Alpha 0.6.0",
    date: "21.3.2026",
    changes: [
      "Improved trading system.",
      "Improved NPC behavior and interactions.",
      "Improved NPC gift interactions.",
      "Improved quest system.",
      "Expanded story content.",
      "Improved NPC relationship system.",
      "Improved dialogue system.",
    ],
  },
  {
    version: "Alpha 0.5.9",
    date: "19.3.2026",
    changes: [
      "Improved quest system.",
      "Improved dialogue system.",
      "Improved NPC behavior and interactions.",
      "Improved respawn behavior.",
      "Improved food setting.",
      "Added clay crafting items.",
      "Fixed bug strawbed.",
    ],
  },
  {
    version: "Alpha 0.5.8",
    date: "17.3.2026",
    changes: [
      "Improved quest system.",
      "Improved item setting.",
      "Various gameplay improvements and bug fixes.",
    ],
  },
  {
    version: "Alpha 0.5.7",
    date: "12.3.2026",
    changes: [
      "Improved tutorial order.",
      "Improved quest system.",
      "Improved handcrafting system.",
      "Improved hydration balancing.",
      "Fixed bug world time.",
      "Improved monster setting.",
      "Fixed carrot icon.",
      "Fixed 7. Deer frezzed anim when attacked.",
      "Fixed solid block item icons.",
    ],
  },
  {
    version: "Alpha 0.5.6",
    date: "9.3.2026",
    changes: [
      "Improved NPC behavior and interactions.",
      "Added stats for items.",
      "Fixed infinite loop reprocess chunk Data.",
      "Added rabbit hunting quest.",
      "Fixed biome po infinit loop.",
      "Improved furnace interactions.",
      "Improved hydration balancing.",
      "Buffed pickaxe mining damage.",
      "Fixed bIsMoving in Monster Main Anim.",
    ],
  },
  {
    version: "Alpha 0.5.5",
    date: "7.3.2026",
    changes: [
      "Improved spawn positioning.",
      "Improved sleeping mechanics.",
      "Fixed bug crash null dynMat.",
      "Fixed bug crash 3 players.",
      "Fixed map center at foot of character instead center.",
      "Fixed fish swim like stupid: end node not set move mode in path finding.",
      "Fixed map zoom.",
    ],
  },
  {
    version: "Alpha 0.5.4",
    date: "5.3.2026",
    changes: [
      "Fixed stacking effects.",
      "Fixed - Multiple hit when attack.",
      "Improved NPC behavior and interactions.",
      "Fixed packaged build issues.",
      "Fixed package version crash / can not gen POI.",
    ],
  },
  {
    version: "Alpha 0.5.3",
    date: "27.2.2026",
    changes: [
      "Improved NPC relationship system.",
      "Improved dialogue system.",
      "Improved NPC behavior and interactions.",
      "Improved quest system.",
    ],
  },
  {
    version: "Alpha 0.5.2",
    date: "20.2.2026",
    changes: [
      "Improved quest system.",
      "Improved trading system.",
      "Fixed jungle gen.",
      "Fixed build package.",
    ],
  },
  {
    version: "Alpha 0.5.1",
    date: "2.2.2026",
    changes: [
      "Improved NPC behavior and interactions.",
      "Improved quest system.",
      "Improved trading system.",
      "Improved dialogue system.",
      "Improved campfire system.",
      "Improved sleeping mechanics.",
      "Fixed right click inventory slot.",
      "Fixed handheld essence.",
    ],
  },
  {
    version: "Alpha 0.5.0",
    date: "22.1.2026",
    changes: [
      "Improved trading system.",
      "Improved NPC behavior and interactions.",
      "Various gameplay improvements and bug fixes.",
    ],
  },
  {
    version: "Alpha 0.4.9",
    date: "16.1.2026",
    changes: [
      "Improved NPC behavior and interactions.",
      "Improved spawn positioning.",
      "Fixed pOI with Bed.",
      "Improved sleeping mechanics.",
    ],
  },
  {
    version: "Alpha 0.4.8",
    date: "13.1.2026",
    changes: [
      "Fixed attackRange using empty hand.",
      "Fixed placeableitem rotation bug.",
      "Improved respawn behavior.",
      "Fixed dead still pickup drop item FIRST before change dead drop grave.",
      "Improved hair customization.",
    ],
  },
  {
    version: "Alpha 0.4.7",
    date: "10.1.2026",
    changes: [
      "Improved spawn positioning.",
      "Fixed cutoff.",
      "Improved NPC behavior and interactions.",
      "Fixed char texture.",
      "Improved dialogue system.",
      "Improved chatIntent.",
    ],
  },
  {
    version: "Alpha 0.4.6",
    date: "31.12.2025",
    changes: [
      "Improved dialogue system.",
      "Improved NPC behavior and interactions.",
      "Fixed intent GetPriority.",
      "Fixed rain visual issues.",
      "Improved spawn positioning.",
    ],
  },
  {
    version: "Alpha 0.4.5",
    date: "23.12.2025",
    changes: [
      "Improved spawn positioning.",
      "Fixed stone texture.",
      "Fixed reprocess chunk data crash game.",
      "Improved hydration balancing.",
      "Fixed rain visual issues.",
      "Fixed gen and player position.",
      "Fixed gen snow.",
    ],
  },
  {
    version: "Alpha 0.4.4",
    date: "14.12.2025",
    changes: [
      "Added vegetation drops.",
      "Fixed rain visual issues.",
      "Various gameplay improvements and bug fixes.",
    ],
  },
  {
    version: "Alpha 0.4.3",
    date: "7.12.2025",
    changes: [
      "Fixed bug block anim crash game when chunk updated.",
      "Fixed monster loop error.",
      "Fixed drop item Crash.",
      "Fixed planting seed.",
      "Added more items.",
    ],
  },
  {
    version: "Alpha 0.4.2",
    date: "30.11.2025",
    changes: [
      "Improved campfire system.",
      "Fixed tree collision.",
      "Improved spawn positioning.",
      "Added some items.",
      "Added new eye customization options.",
      "Improved zombie attack.",
      "Improved boar Attack Intent.",
      "Fixed tree and surface object collision to prevent can not find path.",
      "Fixed findPath - Case only 1 block down.",
    ],
  },
  {
    version: "Alpha 0.4.1",
    date: "25.11.2025",
    changes: [
      "Added rabbit hunting quest.",
      "Improved move method: reduce speed before jump.",
      "Improved NPC behavior and interactions.",
      "Fixed sent chunk to clients.",
    ],
  },
  {
    version: "Alpha 0.4.0",
    date: "17.11.2025",
    changes: [
      "Fixed getMonsterData Crash 4.",
      "Fixed getMonsterData Crash 3.",
      "Fixed getMonsterData Crash 2.",
      "Fixed getMonsterData Crash.",
      "Fixed monster anim setting cause monster sometime disappear.",
      "Fixed getCharacterMovement()->PerchRadiusThreshold = 38 cause laggy on client.",
      "Improved spawn positioning.",
    ],
  },
  {
    version: "Alpha 0.3.9",
    date: "12.11.2025",
    changes: [
      "Fixed bug monster stuck at edge of block.",
      "Fixed bUG: should not save monster post for jumping monster.",
      "Improved spawn positioning.",
      "Fixed monster Drop when reactivate chunk.",
      "Fixed when player Swim/ next to water, can not find path.",
      "Fixed when player jump, can not find path.",
      "Fixed same type monster not attack each other.",
      "Balanced hostile creature spawn rate.",
    ],
  },
  {
    version: "Alpha 0.3.8",
    date: "5.11.2025",
    changes: [
      "Improved spawn positioning.",
      "Improved monster join/ leave nest.",
      "Improved NPC behavior and interactions.",
      "Various gameplay improvements and bug fixes.",
    ],
  },
  {
    version: "Alpha 0.3.7",
    date: "30.10.2025",
    changes: [
      "Improved spawn positioning.",
      "Added new eye customization options.",
      "Added some noti.",
      "Fixed consume item for craft stack with count > 1.",
      "Fixed swim hand held anim.",
      "Fixed setup record landscapr to 1920x1080.",
      "Improved adjacent tile.",
      "Improved tile diff height adjacent.",
    ],
  },
  {
    version: "Alpha 0.3.6",
    date: "21.10.2025",
    changes: [
      "Fixed bP setting for door.",
      "Fixed blueprint for item stack with count > 1.",
      "Improved chunk up face flickering.",
      "Fixed package project.",
      "Improved hydration balancing.",
      "Improved furnace interactions.",
      "Improved handCarry Anim.",
      "Buffed pickaxe mining damage.",
    ],
  },
  {
    version: "Alpha 0.3.5",
    date: "18.10.2025",
    changes: [
      "Fixed bug cancle craft on client for anvil / workbench.",
      "Fixed rain visual issues.",
      "Improved swing anim.",
      "Fixed pOI save/ load door direction not correct.",
    ],
  },
  {
    version: "Alpha 0.3.4",
    date: "11.10.2025",
    changes: [
      "Improved auto cutoff.",
      "Fixed hoe tile.",
      "Added some POIs.",
      "Improved spawn positioning.",
      "Improved cheat manager.",
      "Improved roof visuals.",
      "Fixed texture.",
      "Fixed destroy fence.",
      "Fixed fence normal.",
    ],
  },
  {
    version: "Alpha 0.3.3",
    date: "6.10.2025",
    changes: [
      "Fixed solid block down face Tile is not correct.",
      "Balanced mining damage.",
      "Improved hydration balancing.",
      "Fixed liquid surface cutoff.",
      "Reduced cursor input delay.",
      "Fixed place item hit anim.",
      "Improved seed/ hoe indicator.",
      "Improved placeable item indicator.",
      "Fixed collect item noti template.",
      "Fixed primitive research table Mesh.",
    ],
  },
  {
    version: "Alpha 0.3.2",
    date: "2.10.2025",
    changes: [
      "Improved furnace interactions.",
      "Fixed init item crafting state.",
      "Fixed cancel cooking pot cooking.",
      "Improved campfire system.",
    ],
  },
  {
    version: "Alpha 0.3.1",
    date: "30.9.2025",
    changes: [
      "Fixed save direction when put placeable item.",
      "Fixed rain visual issues.",
      "Various gameplay improvements and bug fixes.",
    ],
  },
  {
    version: "Alpha 0.3.0",
    date: "24.9.2025",
    changes: [
      "Fixed put block occupation.",
      "Fixed player has PickedItem then right click to inventory slot (empty or not).",
      "Fixed notification.",
      "Improved spawn positioning.",
      "Fixed fence shadow noise.",
      "Fixed viewport cutoff issue.",
      "Improved energy slots.",
      "Improved furnace interactions.",
      "Added vegetation drops.",
      "Fixed load and render structure must tick.",
    ],
  },
  {
    version: "Alpha 0.2.9",
    date: "21.9.2025",
    changes: [
      "Added vegetation drops.",
      "Fixed player falls when put solid block right on it: PREVENT PUT BLOCK OVERLAP.",
      "Fixed crab Anim setting.",
      "Improved spawn positioning.",
      "Improved hydration balancing.",
    ],
  },
  {
    version: "Alpha 0.2.8",
    date: "12.9.2025",
    changes: [
      "Improved hydration balancing.",
      "Fixed stat card round issue.",
      "Fixed hUD scale.",
      "Fixed research point shown.",
      "Fixed pixel problem. Offset X CharMesh 1 px to make it align with camera pixel grid.",
    ],
  },
  {
    version: "Alpha 0.2.7",
    date: "9.9.2025",
    changes: [
      "Fixed scaling UI using Application Scale instead of setRenderScale for each widget.",
      "Fixed stat icon path.",
      "Improved node connector visuals.",
      "Various gameplay improvements and bug fixes.",
    ],
  },
  {
    version: "Alpha 0.2.6",
    date: "6.9.2025",
    changes: ["Various gameplay improvements and bug fixes."],
  },
  {
    version: "Alpha 0.2.5",
    date: "4.9.2025",
    changes: [
      "Added item to inventory update ExploredItems.",
      "Improved carry handpos list.",
      "Fixed selected slot background.",
      "Improved respawn behavior.",
      "Improved hydration balancing.",
    ],
  },
  {
    version: "Alpha 0.2.4",
    date: "3.9.2025",
    changes: [
      "Improved spawn positioning.",
      "Improved respawn behavior.",
      "Various gameplay improvements and bug fixes.",
    ],
  },
  {
    version: "Alpha 0.2.3",
    date: "29.8.2025",
    changes: [
      "Fixed run handheld anim.",
      "Fixed regenarate stat UI background.",
      "Fixed packaged build issues.",
      "Fixed save player data.",
    ],
  },
  {
    version: "Alpha 0.2.2",
    date: "28.8.2025",
    changes: [
      "Improved thunder.",
      "Fixed bug CanSeed.",
      "Improved respawn behavior.",
      "Improved hydration balancing.",
      "Added vegetation drops.",
      "Fixed water mesh underground.",
    ],
  },
  {
    version: "Alpha 0.2.1",
    date: "25.8.2025",
    changes: [
      "Fixed water spread when dig transwater.",
      "Added vegetation drops.",
      "Improved furnace interactions.",
      "Fixed mustTick DoesChunkRequireTick.",
      "Improved spawn positioning.",
      "Fixed bug NAN mouse position.",
    ],
  },
  {
    version: "Alpha 0.2.0",
    date: "22.8.2025",
    changes: [
      "Improved campfire system.",
      "Fixed tick change when chunk Z reduce from 256 to 16.",
      "Fixed destroy grass cause random grass disappearing.",
      "Fixed camfire fire visibility.",
      "Fixed tree root.",
      "Improved left click inventory slot.",
    ],
  },
  {
    version: "Alpha 0.1.9",
    date: "19.8.2025",
    changes: [
      "Fixed e Chest -> E Workbench -> CRASH.",
      "Fixed scroll inventory.",
      "Improved NPC behavior and interactions.",
      "Added rabbit hunting quest.",
      "Fixed render fence.",
      "Fixed water material.",
    ],
  },
  {
    version: "Alpha 0.1.8",
    date: "16.8.2025",
    changes: [
      "Fixed liquid surface underground cut into solid block.",
      "Fixed bug mine when indicator not enabled.",
      "Fixed vertex gap.",
      "Fixed wearable not load on packaged build.",
      "Improved spawn positioning.",
    ],
  },
  {
    version: "Alpha 0.1.7",
    date: "4.8.2025",
    changes: [
      "Improved spawn positioning.",
      "Fixed data compression wrong.",
      "Added rabbit hunting quest.",
      "Various gameplay improvements and bug fixes.",
    ],
  },
  {
    version: "Alpha 0.1.6",
    date: "30.7.2025",
    changes: [
      "Improved spawn positioning.",
      "Fixed placeable item indicator.",
      "Fixed rain visual issues.",
      "Fixed underground light bleeding.",
      "Fixed chunk data compression.",
    ],
  },
  {
    version: "Alpha 0.1.5",
    date: "22.7.2025",
    changes: [
      "Fixed notRender PlaceableItem.",
      "Improved hydration balancing.",
      "Improved spawn positioning.",
      "Fixed bug monster anim not play: No constructor for FMonsterMainAnimInfo causing PosInMainTex NAN.",
      "Added clay crafting items.",
    ],
  },
  {
    version: "Alpha 0.1.4",
    date: "14.7.2025",
    changes: [
      "Improved cutoff up/ down face: not show top block when jump.",
      "Improved cut off side face.",
      "Fixed missing sparkling effects.",
      "Fixed wrong Part Render Range.",
      "Improved spawn positioning.",
      "Added clay crafting items.",
      "Fixed tile gap.",
      "Fixed adjacent Tile make left side face not variant.",
      "Fixed subblock & block not BLOCK each other.",
      "Fixed gap between chunk actors & chunk parts.",
      "Fixed side face cutoff: only use low cutoff for front/ back face.",
      "Fixed bug vertex variant at chunk edge.",
      "Fixed getNeighborState.",
      "Fixed mining outside range.",
    ],
  },
  {
    version: "Alpha 0.1.3",
    date: "8.7.2025",
    changes: [
      "Improved spawn positioning.",
      "Fixed fruit Pos In Tree.",
      "Fixed tree Mat Fruit.",
      "Various gameplay improvements and bug fixes.",
    ],
  },
  {
    version: "Alpha 0.1.2",
    date: "27.6.2025",
    changes: [
      "Added vegetation drops.",
      "Fixed tree & ontree fruit material bug.",
      "Fixed rain visual issues.",
      "Fixed tree mat Encode.",
      "Added multiple Fruit to tree Material.",
      "Added fruit to tree material.",
    ],
  },
  {
    version: "Alpha 0.1.1",
    date: "22.6.2025",
    changes: [
      "Fixed bug water.",
      "Various gameplay improvements and bug fixes.",
    ],
  },
  {
    version: "Alpha 0.1.0",
    date: "12.6.2025",
    changes: [
      "Added collect salt quest.",
      "Fixed rain visual issues.",
      "Fixed gen river.",
      "Various gameplay improvements and bug fixes.",
    ],
  },
  {
    version: "Alpha 0.0.9",
    date: "27.5.2025",
    changes: [
      "Improved handcrafting system.",
      "Various gameplay improvements and bug fixes.",
    ],
  },
  {
    version: "Alpha 0.0.8",
    date: "17.5.2025",
    changes: [
      "Fixed rain visual issues.",
      "Improved process Intent.",
      "Improved NPC behavior and interactions.",
      "Added and Pause Intent.",
    ],
  },
  {
    version: "Alpha 0.0.7",
    date: "14.5.2025",
    changes: [
      "Fixed left-Right door open direction.",
      "Fixed bug // Check to make sure house under floor blocks: // On Solid blocks // Same init noise height.",
      "Fixed door indicator.",
      "Fixed init outline on client.",
    ],
  },
  {
    version: "Alpha 0.0.6",
    date: "9.5.2025",
    changes: [
      "Fixed performance Gen chunk.",
      "Improved spawn positioning.",
      "Fixed bug random river width.",
      "Improved campfire system.",
      "Fixed many GPU hardware setups (and some shaders!) don't like UV coordinates going above 2048 or 4096. So we clamp UV %2048.",
    ],
  },
  {
    version: "Alpha 0.0.5",
    date: "27.4.2025",
    changes: [
      "Fixed drop item priority destroyer.",
      "Balanced tool durability.",
      "Improved campfire system.",
      "Various gameplay improvements and bug fixes.",
    ],
  },
  {
    version: "Alpha 0.0.4",
    date: "23.4.2025",
    changes: [
      "Improved campfire system.",
      "Improved roof visuals.",
      "Fixed drop item collected.",
      "Fixed autoAttack.",
      "Improved handcrafting system.",
      "Fixed package window.",
      "Improved furnace interactions.",
    ],
  },
  {
    version: "Alpha 0.0.3",
    date: "20.4.2025",
    changes: [
      "Improved handcrafting system.",
      "Added wearable, Wearable affect Stats.",
      "Various gameplay improvements and bug fixes.",
    ],
  },
  {
    version: "Alpha 0.0.2",
    date: "12.4.2025",
    changes: [
      "Improved NPC behavior and interactions.",
      "Improved spawn positioning.",
      "Fixed bug | UI update when scoop water, sow seed, water durability.",
      "Fixed carry hand pos.",
      "Fixed door Collision.",
    ],
  },
  {
    version: "Alpha 0.0.1",
    date: "30.3.2025",
    changes: [
      "Added new door texture.",
      "Fixed thunder not trigger.",
      "Fixed ridirect.",
      "Fixed gen Tree and grass.",
      "Fixed rain visual issues.",
    ],
  },
];
